<p
  #textContent
  [ngClass]="{ trimmed: showExpand && !expanded }"
  [ngStyle]="{ 'max-height': trim && !expanded ? MAX_HEIGHT + 'px' : '' }"
>
  {{ text }}
</p>
@if (showExpand && !expanded) {
<span data-testid="expand-button" class="expand-button" (click)="expand()"
  >Expand</span
>
}
